import React, { useEffect, useState } from "react";
import OffCanvasModal from "../../components/OffCanvasModal";
import ImageInput from "../../components/ImageInput";
import CropPopup from "../../components/CropPopup";
import ConfirmationPopup from "../../components/ConfirmationPopup";
import CountryCode from "../../config/countryCode.json";
import Input from "../../components/Input";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../helpers/axios";
import { dataURItoBlob, getCountryFromSettings } from "../../helpers/utils";
import {
  DuplicateCheck,
  IMAGE_BASE_URL,
  SORT_KEY_NAME,
  SORT_KEY_RECENT,
  SORT_ORDER_ASC,
  SORT_ORDER_DESC,
} from "../../helpers/constants";
import PrimaryHeader from "../../components/PrimaryHeader";
import CustomSelect from "../../components/CustomSelect";
import { Link, useLocation } from "react-router-dom";
import DealerGridItem from "./components/DealerGridItem";
import { setDealerAccountsFilter } from "../../redux/slice/dealerAccountsSlice";
import { toast } from "react-toastify";
import { LoaderComp } from "../../components";
import CustomerGridItem from "./components/CustomerGridItem";
import { SecurityPinNumber } from "./components/SecurityPinNumber";

export default function Customers() {
  const location = useLocation();
  const pagePermission = location.state;
  const dispatch = useDispatch();
  const dealerAccountsFilter = useSelector(
    (state) => state?.dealerAccountFilter?.dealerAccountsFilter
  );
  //console.log("dealerAccountsFilter", dealerAccountsFilter);
  const [anchorEls, setAnchorEls] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showManageModal, setShowManageModal] = useState(false);
  const [activeTab, setActiveTab] = useState(
    Object.keys(dealerAccountsFilter)?.length > 0
      ? dealerAccountsFilter
      : { parameter: "status", value: 1 }
  );
  const [featureModal, setFeatureModal] = useState({
    show: false,
    id: null,
    status: null,
  });
  const [inactiveModal, setInactiveModal] = useState({
    show: false,
    id: null,
    status: null,
  });
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    id: null,
    status: null,
  });
  const [tabData, setTabData] = useState([
    { label: "Pending", count: null, value: 0 },
    { label: "Approved", count: null, value: 1 },
    { label: "Rejected", count: null, value: 2 },
  ]);

  const authInfo = useSelector((state) => state.auth);
  const [searchText, setSearchText] = useState("");
  const [sort, setSort] = useState({
    sortKey: SORT_KEY_NAME,
    sortOrder: SORT_ORDER_ASC,
  });
  const [loading, setLoading] = useState(false);

  const [tabFilterData, setTabFilterData] = useState([]);
  const [items, setItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [userId, setUserId] = useState(null);

  async function getDealers(type) {
    setLoading(true);
    const tabKey = { [`${activeTab.parameter}`]: activeTab.value };
    let res = await axios.post(
      `/admin/customer/list/24/${currentPage}`,
      {
        keyword: searchText,
        sortKey: sort.sortKey,
        sortOrder: sort.sortOrder,
        status: activeTab?.value

      }
    );
    if (res.status < 400) {
      setLoading(false);
      setItems(
        items?.length > 0
          ? type !== undefined ? res.data.data : DuplicateCheck(items?.concat(res.data.data))
          : res.data.data
      );
      setTabData(res.data.counts);
      setTabFilterData(
        tabFilterData?.length > 0
          ? type !== undefined ? res.data.data : DuplicateCheck(tabFilterData?.concat(res.data.data))
          : res.data.data
      );
      setTotalData(res.data?.total);
      window.scrollTo(0, 248);
    }

  }

  //console.log("items", items)

  const handleScroll = () => {
    //console.log("WINDOWOFFSET", window.scrollY)
    if (
      Math.round(window.innerHeight) +
      Math.round(document.documentElement.scrollTop) !==
      Math.round(document.documentElement.offsetHeight)
    ) {
      if (
        document.documentElement.offsetHeight -
        (window.innerHeight +
          Math.round(document.documentElement.scrollTop)) <=
        1
      ) {
        if (tabFilterData?.length < totalData && !loading) {
          setCurrentPage(currentPage + 1);
          getDealers(currentPage + 1, "scroll");
        }
      } else {
        return;
      }
    } else {
      if (tabFilterData?.length < totalData && !loading) {
        setCurrentPage(currentPage + 1);
        getDealers(currentPage + 1, "scroll");
      }
    }
  };

  const handleLogin = (id) => {
    //  setAnchorEls(Array(tabFilterData.length).fill(null));
    setMenuOpen(false);
    setIsLoginModalOpen(true);
    setUserId(id);
  };
  //console.log("totalData", totalData)

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading]);

  useEffect(() => {
    async function getDealers() {
      setLoading(true);
      setCurrentPage(1);
      const tabKey = { [`${activeTab.parameter}`]: activeTab.value };
      //console.log("key", tabKey);
      let res = await axios.post(
        `/admin/customer/list/24/1`,
        {
          keyword: searchText,
          sortKey: sort.sortKey,
          sortOrder: sort.sortOrder,
          status: activeTab?.value

        }
      );
      setItems(res.data.data);
      setTabData(res.data.counts);
      setTabFilterData(res.data.data);
      setTotalData(res.data?.total);

      setLoading(false);
    }
    getDealers();
  }, [activeTab, sort]);

  // useEffect(() => {
  //   async function getDealers() {
  //     setLoading(true);
  //     setCurrentPage(1);
  //     let res = await axios.post(
  //       `/admin/customer/list/24/1`,
  //       {
  //         keyword: searchText,
  //         sortKey: sort.sortKey,
  //         sortOrder: sort.sortOrder,
  //         status: activeTab?.value

  //       }
  //     );
  //     setItems(res.data.data);
  //     setTabData(res.data.counts);
  //     setTabFilterData(res.data.data);
  //     setTotalData(res.data?.total);

  //     setLoading(false);
  //   }
  //   if (searchText && searchText.length > 1) getDealers();
  //   else if (searchText === "") getDealers();
  // }, [searchText]);

  useEffect(() => {
    setAnchorEls(Array(tabFilterData?.length).fill(null));
  }, [tabFilterData]);

  const onChange = (data) => {
    dispatch(setDealerAccountsFilter(data));
  };

  const confirmFeatured = async (id, status) => {
    try {
      let itemData = tabFilterData.find((item) => item.id === id);
      let res = await axios.put(`/admin/customer/update/${id}`, {
        ...itemData,
        featured: !status,
      });
      if (res.data.resp_code) {
        await getDealers();
        setFeatureModal((data) => ({
          ...data,
          id: null,
          status: null,
          show: false,
        }));
      } else throw { response: "Invalid response" };
    } catch (error) {
      Object.keys(error.response.data.errors).forEach(function (key) {
        toast.error(
          error.response.data.errors[key] !== undefined
            ? error.response.data.errors[key]
            : "Error occured profile not updated..!"
        );
      });
    }
  };

  const confirmInactive = async (id, status) => {
    let updatedList = items.map((item) => {
      if (item.id == id) {
        return { ...item, inactive: !status };
      }
      return item;
    });
    //console.log(updatedList);
    setItems(updatedList);
    setInactiveModal((data) => ({
      ...data,
      show: false,
      id: null,
      status: false,
    }));
  };

  const confirmDelete = async (id) => {
    try {
      let res = await axios.delete(`/admin/customer/delete/${id}`);
      //console.log("DELETE", res);
      if (res.status < 400) {
        toast.error(res.data?.message);
        setDeleteModal(false);
        getDealers("delete");

      }
    } catch (error) {
      alert("Invalid Response");
    }
    setDeleteModal((data) => ({
      ...data,
      show: false,
      id: null,
      status: false,
    }));
  };

  const handleOpenMenu = (index, event) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = event.currentTarget;
    setAnchorEls(newAnchorEls);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEls(Array(tabFilterData.length).fill(null));
    setMenuOpen(false);
  };

  const onDeleteClick = async (id) => {
    setDeleteModal((data) => ({ ...data, id: id, show: true }));
  };

  return (
    <div className="main_content flex-[1] bg-[#F5F5F5] w-[100%] min-h-screen">
      <PrimaryHeader
        sort={sort}
        setSort={setSort}
        title={"Customer Accounts"}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        btnTitle={"Create New Customer"}
        tabData={tabData}
        setShowModal={setShowManageModal}
        searchText={searchText}
        setSearchText={setSearchText}
        onChange={onChange}
        pagePermission={pagePermission}
      />
      <div className="p-[50px_25px]">
        {!loading ? (
          <div className="flex flex-wrap gap-[35px_20px]">
            {items.length == 0 && (
              <h2 class="font-[700] text-2xl text-center w-full">No Results</h2>
            )}
            {tabFilterData.map((item, index) => {
              return (
                <CustomerGridItem
                  anchorEl={anchorEls[index]}
                  menuOpen={menuOpen && anchorEls[index] !== null}
                  handleOpenMenu={handleOpenMenu}
                  handleCloseMenu={handleCloseMenu}
                  handleLogin={handleLogin}
                  index={index}
                  key={index}
                  data={item}
                  onDeleteClick={onDeleteClick}
                  pagePermission={pagePermission}
                />
              );
            })}
          </div>
        ) : (
          <LoaderComp />
        )}
      </div>
      {isLoginModalOpen && <SecurityPinNumber
        open={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        id={userId}
        type={'enduser'}
        onConfirm={(pin) => {
          // Validate pin or perform login
          //  navigate(`/login-as-agent/${data.id}`);
          setIsLoginModalOpen(false);
        }}
      />}
      {showManageModal ? (
        <CreateModal
          active={showManageModal}
          setActive={setShowManageModal}
          setItems={setItems}
          getDealers={getDealers}
        />
      ) : null}
      {featureModal.show ? (
        <ConfirmationPopup
          type={"feature"}
          setActiveData={setFeatureModal}
          activeData={featureModal}
          onConfirm={confirmFeatured}
        />
      ) : null}
      {inactiveModal.show ? (
        <ConfirmationPopup
          type={"inactive"}
          setActiveData={setInactiveModal}
          activeData={inactiveModal}
          onConfirm={confirmInactive}
        />
      ) : null}
      {deleteModal.show ? (
        <ConfirmationPopup
          type={"delete"}
          setActiveData={setDeleteModal}
          activeData={deleteModal}
          onConfirm={confirmDelete}
        />
      ) : null}
    </div>
  );
}

const CreateModal = ({ active, setActive, setItems, getDealers }) => {
  const errData = {
    name: false,
    email: false,
    password: false,
    confirmPassword: false,
    passwordMatch: false,
    icon: false,
    country_code: false,
    phone_number: false,
    featured: false,
    id: false,
    address_line1: false,
    address_line2: false,
    country: false,
    postal_code: false,
  };
  const [createData, setCreateData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    passwordMatch: false,
    icon: "public/uploads/agent/659b9cf96ee75.jpg",
    country_code: "+65",
    phone_number: null,
    address_line1: "",
    address_line2: "",
    country: "SG",
    postal_code: null,
  });

  const [image, setImage] = useState(null);
  const [showCrop, setShowCrop] = useState(false);
  const [croppedImage, setCroppedImage] = useState();
  const settings = useSelector((state) => state.settings);
  const [viewMode, setViewMode] = useState(false);
  const [errors, setErrors] = useState(errData);
  const [loading, setLoading] = useState(false);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setCreateData({
        ...createData,
        icon: "",
      });
      setShowCrop(true);
      setImage(URL.createObjectURL(event.target.files[0]));
    }
  };

  //console.log("createData", createData);

  const onSubmit = async (e) => {
    try {
      setErrors(errData);
      e.preventDefault();
      if (createData.password !== createData.confirmPassword) {
        setErrors((data) => ({
          ...data,
          confirmPassword: "Password does not match",
        }));
        return false;
      } else if (!croppedImage) {
        setErrors((data) => ({ ...data, icon: "Please upload the logo" }));
        return false;
      }
      setLoading(true);
      let blobFile = await dataURItoBlob(croppedImage);
      let formData = new FormData();
      formData.append("file", blobFile, "crop-icon.jpg");
      formData.append("module", "customer");
      let fileRes = await axios.post("/admin/upload/image", formData);

      let res = await axios.post("/admin/customer/create", {
        ...createData,
        avatar: fileRes.data.data,
      });
      if (res.status < 400) {
        getDealers();
        toast.success(res.data?.message);
        setCreateData((data) => ({
          ...data,
          icon: fileRes.data.data,
          id: res.data.data.id,
        }));
        setViewMode(true);
        setLoading(false);
        setActive(false);
      }
    } catch (error) {
      setErrors(error.response.data.errors);
      Object.keys(error.response.data.errors).forEach(function (key) {
        toast.error(
          error.response.data.errors[key] !== undefined
            ? error.response.data.errors[key]
            : "Error occured profile not updated..!"
        );
      });
      setLoading(false);
    }
  };

  // const onCrate
  return (
    <>
      <OffCanvasModal
        title={"Create new Customer"}
        active={active}
        setActive={setActive}
      >
        <form className="w-full" onSubmit={onSubmit}>
          <div className="grid grid-cols-2 gap-x-3 gap-y-3 md:gap-y-4">
            <div className="col-span-1">
              <label>Customer Name*</label>
              <Input
                required={true}
                viewMode={viewMode}
                value={createData.name}
                placeholder={"Enter Full Name"}
                setValue={(value) =>
                  setCreateData((data) => ({ ...data, name: value }))
                }
                error={errors?.name}
              />
            </div>
            <div className="col-span-1">
              <label>Customer Email*</label>
              <Input
                type="email"
                required={true}
                viewMode={viewMode}
                value={createData.email}
                placeholder={"Enter Email address"}
                setValue={(value) =>
                  setCreateData((data) => ({ ...data, email: value }))
                }
                error={errors?.email}
              />
            </div>
            <div className="col-span-1">
              <label>Password*</label>
              <Input
                type="password"
                value={createData.password}
                error={errors?.password}
                required={true}
                viewMode={viewMode}
                placeholder={"Enter Password"}
                setValue={(value) =>
                  setCreateData((data) => ({ ...data, password: value }))
                }
              />
            </div>
            <div className="col-span-1">
              <label>Confirm Password</label>
              <Input
                type="password"
                value={createData.confirmPassword}
                required={true}
                viewMode={viewMode}
                placeholder={"Confirm Password"}
                setValue={(value) =>
                  setCreateData((data) => ({ ...data, confirmPassword: value }))
                }
                error={errors?.confirmPassword}
              />
            </div>
          </div>
          <div className="mt-5">
            <p className="text-sm tracking-tight font-semibold mb-6">
              Customer Details
            </p>
            <div className="grid grid-cols-3 mt-2 gap-x-3 gap-y-3">
              <div className="col-span-3 md:col-span-1">
                <label>Customer&apos;s Profile*</label>
                {viewMode ? (
                  <img
                    src={`${IMAGE_BASE_URL}/${createData.icon}`}
                    className="h-5 w-5 rounded-md"
                  />
                ) : (
                  <ImageInput
                    viewMode={viewMode}
                    image={
                      createData.icon && createData.icon !== ""
                        ? `${IMAGE_BASE_URL}/${createData.icon}`
                        : croppedImage
                    }
                    setImage={onImageChange}
                    error={errors ? errors["icon"] : null}
                  />
                )}
              </div>
              <div className="md:col-span-2 col-span-3 gap-x-2">
                <div className="grid grid-cols-4 justify-between gap-x-3">
                  <div>
                    <label>Country Code{!viewMode ? "*" : null}</label>
                    {viewMode ? (
                      <p className="text-base text-black">
                        {createData.country_code}
                      </p>
                    ) : (
                      <CustomSelect
                        customLabel={"dial_code"}
                        customValue={"dial_code"}
                        required={true}
                        disabled={viewMode}
                        placeholder={"Select Country Code"}
                        options={CountryCode}
                        value={createData.country_code}
                        setValue={(value) =>
                          setCreateData((data) => ({
                            ...data,
                            country_code: value,
                          }))
                        }
                      />
                    )}
                  </div>
                  <div className="col-span-3">
                    <label>Contact Number{!viewMode ? "*" : null}</label>
                    <Input
                      type="text"
                      number={true}
                      value={createData.phone_number}
                      required={true}
                      viewMode={viewMode}
                      placeholder={"Contact Number"}
                      setValue={(value) =>
                        setCreateData((data) => ({
                          ...data,
                          phone_number: value,
                        }))
                      }
                      maxLength={8}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className=" mt-3">
              <div>
                <label>{viewMode ? "Address Line 1*" : "Address"}</label>
                <Input
                  type="text"
                  value={createData.address_line1}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Address 1 ( Floor, Unit No., Street Name)"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, address_line1: value }))
                  }
                />
              </div>
            </div>
            <div className="mt-3">
              <div>
                {viewMode ? <label>Address Line 2</label> : null}
                <Input
                  type="text"
                  value={createData.address_line2}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Address Line 2"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, address_line2: value }))
                  }
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-x-3 mt-3">
              <div>
                {viewMode ? <label>Postal Code</label> : null}
                <Input
                  type="text"
                  value={createData.postal_code}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Postal Code"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, postal_code: value }))
                  }
                />
              </div>
              <div>
                {viewMode ? (
                  <p className="text-base text-black">
                    {getCountryFromSettings(createData.country)}
                  </p>
                ) : (
                  <CustomSelect
                    required={true}
                    disabled={viewMode}
                    placeholder={"Select Country"}
                    customValue={"code"}
                    options={CountryCode}
                    value={createData.country}
                    setValue={(value) =>
                      setCreateData((data) => ({ ...data, country: value }))
                    }
                    error={errors ? errors["country"] : null}
                  />
                )}
              </div>
            </div>
            {/* <div className="mt-5">
              <p className="text-sm tracking-tight font-semibold mb-6">
                Point of contact
              </p>
              <div className="grid grid-cols-2 gap-x-3 gap-y-4">
                <div className="col-span-1">
                  <label>Name</label>
                  <Input
                    type="text"
                    value={createData.contacts[0].name}
                    required={true}
                    viewMode={viewMode}
                    placeholder={"Name"}
                    setValue={(value) =>
                      setCreateData((data) => ({
                        ...data,
                        contacts: [
                          (data.contacts[0] = {
                            ...data.contacts[0],
                            name: value,
                          }),
                        ],
                      }))
                    }
                  />
                </div>
                <div className="col-span-1">
                  <label>Designation</label>
                  <Input
                    type="text"
                    value={createData.contacts[0].designation}
                    required={true}
                    viewMode={viewMode}
                    placeholder={"Designation"}
                    setValue={(value) =>
                      setCreateData((data) => ({
                        ...data,
                        contacts: [
                          (data.contacts[0] = {
                            ...data.contacts[0],
                            designation: value,
                          }),
                        ],
                      }))
                    }
                  />
                </div>
                <div className="col-span-2 md:col-span-1 gap-x-2">
                  <div className="grid grid-cols-3 justify-between gap-x-3">
                    <div>
                      <label>Country Code</label>
                      {viewMode ? (
                        <p className="text-base text-black">
                          {createData.contacts[0].country_code}
                        </p>
                      ) : (
                        <CustomSelect
                          customLabel={"dial_code"}
                          customValue={"dial_code"}
                          required={true}
                          disabled={viewMode}
                          placeholder={"Select Country"}
                          options={CountryCode}
                          value={createData.contacts[0].country_code}
                          setValue={(value) =>
                            setCreateData((data) => ({
                              ...data,
                              contacts: [
                                (data.contacts[0] = {
                                  ...data.contacts[0],
                                  country_code: value,
                                }),
                              ],
                            }))
                          }
                          error={
                            errors &&
                              errors["contacts"] &&
                              errors["contacts"][0]
                              ? errors["contacts"][0]["country_code"]
                              : null
                          }
                        />
                      )}
                    </div>
                    <div className="col-span-2">
                      <label>Contact Number</label>
                      <Input
                        type="text"
                        value={createData.contacts[0].phone_number}
                        required={true}
                        viewMode={viewMode}
                        placeholder={"Contact Number"}
                        setValue={(value) =>
                          setCreateData((data) => ({
                            ...data,
                            contacts: [
                              (data.contacts[0] = {
                                ...data.contacts[0],
                                phone_number: value,
                              }),
                            ],
                          }))
                        }
                        error={
                          errors && errors["contacts"] && errors["contacts"][0]
                            ? errors["contacts"][0]["contactNumber"]
                            : null
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-span-2 md:col-span-1">
                  <label>Email address</label>
                  <Input
                    type="email"
                    value={createData.contacts[0].email}
                    required={true}
                    viewMode={viewMode}
                    placeholder={"Enter Email"}
                    setValue={(value) =>
                      setCreateData((data) => ({
                        ...data,
                        contacts: [
                          (data.contacts[0] = {
                            ...data.contacts[0],
                            email: value,
                          }),
                        ],
                      }))
                    }
                  />
                </div>
              </div>
            </div> */}
          </div>
          <div className="flex mt-6">
            {viewMode ? (
              <Link
                to={`/accounts/dealers/${createData.id}`}
                className="btn-md"
              >
                View
              </Link>
            ) : (
              <button
                className="btn-md capitalize"
                type="submit"
                disabled={loading}
              >
                Create Customer
              </button>
            )}
            <button
              className="ml-4 btn-md-disabled"
              onClick={() => setActive(false)}
            >
              {viewMode ? "Close" : "Cancel"}
            </button>
          </div>
        </form>
      </OffCanvasModal>
      {showCrop ? (
        <CropPopup
          image={image}
          setActive={setShowCrop}
          setImage={setCroppedImage}
        />
      ) : null}
    </>
  );
};
